

export {
  PrivacyText,
  PrivacyPolicyDialog,
  TermsText,
  TermsAndConditionsDialog,
} from "lib-core"






